import React from 'react'
import styled from '@emotion/styled'
import { useStateContext } from '../contexts/ContextProvider'
import {TextField, Grid, IconButton, Paper, Button} from '@mui/material'
import CachedIcon from '@mui/icons-material/Cached';

const Container = styled(Paper)({
    marginTop: '10px',
    display: 'flex',
    flexDirection: 'column',
    padding: '10px',
    boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.2)',
    borderRadius: '10px',
    width: '90%',  
})

const ActionContainer = styled.div`
    margin-top: auto;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
`;

function ManageFilter() {
    const { manageFilter, setManageFilter } = useStateContext();

    const handleInputChange = event => {
        const { name, value } = event.target;
        setManageFilter(prevState => ({
            ...prevState,
            [name]: value,
        }));
    };

    return (
        <Container>
            <Grid container spacing={3}>
                <Grid item xs={12} sm={6} md={2.5}> 
                <TextField
                    fullWidth
                    label="Name"
                    name="name"
                    value={manageFilter.name}
                    onChange={handleInputChange}
                    size="small"
                />
                </Grid> 
                <Grid item xs={12} sm={6} md={2.5}> 
                <TextField
                    fullWidth
                    label="UEN number"
                    name="uen_number"
                    value={manageFilter.uen_number}
                    onChange={handleInputChange}
                    size="small"
                />
                </Grid> 
                <Grid item xs={12} sm={6} md={2.5}> 
                <TextField
                    fullWidth
                    label="Company"
                    name="company"
                    value={manageFilter.company}
                    onChange={handleInputChange}
                    size="small"
                />
                </Grid> 
                <Grid item xs={12} sm={6} md={2.5}> 
                <TextField
                    fullWidth
                    label="Mobile"
                    name="mobile"
                    value={manageFilter.mobile}
                    onChange={handleInputChange}
                    size="small"
                />
                </Grid> 
                <ActionContainer>
                    <IconButton onClick={() => {
                        setManageFilter({
                            name:"",
                            uen_number:"",
                            company:"",
                            mobile:"",
                        })
                    }}>
                    <CachedIcon />
                    </IconButton>
                </ActionContainer>
            </Grid>
        </Container>
    )
}

export default ManageFilter